export default "__VITE_ASSET__ddcb1656__"